import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarContent from './SnackbarContent';
import SnackbarSmallTitle from './SnackbarSmallTitle';
import SnackbarAction from './SnackbarAction';

export default function SnackbarProviderForecastPeriodicityRestore({ id, message, action }) {
    const { t } = useTranslation('forecasts');

    const handleAction = () => {
        toast.dismiss(id);
        action?.();
    };

    return (
        <SnackbarCard>
            <SnackbarLayout>
                <SnackbarContent>
                    <SnackbarSmallTitle>{message}</SnackbarSmallTitle>
                </SnackbarContent>
                <SnackbarAction>
                    <Button size="small" variant="primary" onClick={handleAction}>
                        {t('restore')}
                    </Button>
                </SnackbarAction>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarProviderForecastPeriodicityRestore.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    message: PropTypes.string.isRequired,
    action: PropTypes.func,
};
